import { render, staticRenderFns } from "./MenuSidebar.vue?vue&type=template&id=09ae371e&scoped=true&"
import script from "./MenuSidebar.vue?vue&type=script&lang=js&"
export * from "./MenuSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MenuSidebar.vue?vue&type=style&index=0&id=09ae371e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae371e",
  null
  
)

export default component.exports